module.exports = __webpack_public_path__ + "img/logo-full.86322032.png";